import React from "react";

const TermsOfUseSection = ({ title, children }) => (
  <div className="terms-of-use-section tw-mb-6">
    <h3 className="text-lg font-semibold tw-text-xl">{title}</h3>
    <p className="mt-2">{children}</p>
  </div>
);

const TermsOfUse = () => {
  return (
    <>
      <div className="terms-of-use">
        <h1 className="tw-text-2xl tw-font-bold tw-mb-4">Terms of Use</h1>
        <TermsOfUseSection title="1. Acceptance of Terms">
          Welcome to We are uniters! By using our website, products, and
          services, you agree to be bound by these Terms of Use. If you do not
          agree with any part of these terms, please refrain from using our
          website and services.
        </TermsOfUseSection>

        <TermsOfUseSection title="2. User Conduct">
          When using We are uniters, you agree not to:
          <ul className="list-inside list-disc">
            <li>
              Engage in any activity that could harm, disrupt, or interfere with
              our website or services.
            </li>
            <li>
              Use our website and services for illegal or unauthorized purposes.
            </li>
            <li>
              Violate any applicable laws, regulations, or third-party rights.
            </li>
          </ul>
        </TermsOfUseSection>

        <TermsOfUseSection title="3. Intellectual Property">
          All content on our website and services, including but not limited to
          text, images, logos, and software, is protected by intellectual
          property laws. You may not use or distribute this content without our
          express written consent.
        </TermsOfUseSection>

        <TermsOfUseSection title="4. Privacy and Data Collection">
          Your use of We are uniters is subject to our Privacy Policy. Please
          review our Privacy Policy to understand how we collect, use, and
          protect your data.
        </TermsOfUseSection>

        <TermsOfUseSection title="5. Termination">
          We reserve the right to terminate or suspend your access to our
          website or services at our discretion, without notice, for violations
          of these Terms of Use.
        </TermsOfUseSection>

        <TermsOfUseSection title="6. Links to Third-Party Websites">
          We are uniters may contain links to third-party websites. These links
          are provided for your convenience, but we do not endorse or control
          the content on these websites. We are not responsible for any issues
          or damages that may arise from your use of third-party websites.
        </TermsOfUseSection>

        <TermsOfUseSection title="7. Limitation of Liability">
          We are uniters is not liable for any damages or losses incurred from
          the use of our website or services. Your use of our website is at your
          own risk.
        </TermsOfUseSection>

        <TermsOfUseSection title="8. Changes to Terms of Use">
          We may update these Terms of Use from time to time. Any changes will
          be posted on our website, and it is your responsibility to review them
          periodically. Continued use of our website after changes are made
          implies your acceptance of the revised terms.
        </TermsOfUseSection>

        <TermsOfUseSection title="9. Governing Law">
          The company is not responsible for any dealings between the
          beneficiary of the company's services and any of its individuals. The
          company is only responsible for financial transactions between the
          beneficiary and the company's official account.
        </TermsOfUseSection>

        <TermsOfUseSection title="10. Contact Information">
          If you have any questions or concerns regarding these Terms of Use,
          please contact us using the information provided in our "Contact
          Information" section in the Privacy Policy.
        </TermsOfUseSection>

        <TermsOfUseSection title="11. No Refund After 14 Days">
          No refund after 14 days of creating the personal account.
        </TermsOfUseSection>

        <p className="mt-4 text-sm text-gray-500">
          These Terms of Use were last updated on 10 August, 2024. Thank you for
          choosing We are uniters, and we appreciate your compliance with these
          terms.
        </p>
      </div>
      <div dir="rtl">
        <h1 className="tw-text-2xl tw-font-bold !tw-my-4">شروط الاستخدام</h1>

        <TermsOfUseSection title="1. قبول الشروط">
          مرحبًا بكم في "وي ار يونيترز"! باستخدامك لموقعنا الإلكتروني ومنتجاتنا
          وخدماتنا، فإنك توافق على الالتزام بشروط الاستخدام هذه. إذا كنت لا
          توافق على أي جزء من هذه الشروط، يُرجى الامتناع عن استخدام موقعنا
          وخدماتنا.
        </TermsOfUseSection>

        <TermsOfUseSection title="2. سلوك المستخدم">
          عند استخدامك لـ "وي ار يونيترز"، توافق على عدم:
          <ul className="list-inside list-disc">
            <li>
              الانخراط في أي نشاط قد يتسبب في إلحاق الضرر أو التعطيل أو التدخل
              في موقعنا الإلكتروني أو خدماتنا.
            </li>
            <li>
              استخدام موقعنا الإلكتروني وخدماتنا لأغراض غير قانونية أو غير مصرح
              بها.
            </li>
            <li>انتهاك أي قوانين أو لوائح أو حقوق طرف ثالث سارية.</li>
          </ul>
        </TermsOfUseSection>

        <TermsOfUseSection title="3. الملكية الفكرية">
          جميع المحتويات على موقعنا الإلكتروني وخدماتنا، بما في ذلك على سبيل
          المثال لا الحصر النصوص والصور والشعارات والبرمجيات، محمية بموجب قوانين
          الملكية الفكرية. لا يجوز لك استخدام أو توزيع هذه المحتويات دون الحصول
          على موافقتنا الخطية الصريحة.
        </TermsOfUseSection>

        <TermsOfUseSection title="4. الخصوصية وجمع البيانات">
          يخضع استخدامك لـ "وي ار يونيترز" لسياسة الخصوصية الخاصة بنا. يُرجى
          مراجعة سياسة الخصوصية لفهم كيفية جمعنا واستخدامنا وحمايتنا لبياناتك.
        </TermsOfUseSection>

        <TermsOfUseSection title="5. الإنهاء">
          نحتفظ بالحق في إنهاء أو تعليق وصولك إلى موقعنا الإلكتروني أو خدماتنا
          وفقًا لتقديرنا الخاص، دون إشعار، في حالة انتهاكك لشروط الاستخدام هذه.
        </TermsOfUseSection>

        <TermsOfUseSection title="6. الروابط إلى مواقع الطرف الثالث">
          قد يحتوي "وي ار يونيترز" على روابط إلى مواقع طرف ثالث. تُقدم هذه
          الروابط لراحتك، ولكننا لا ندعم أو نتحكم في المحتوى الموجود على هذه
          المواقع. نحن غير مسؤولين عن أي مشاكل أو أضرار قد تنشأ من استخدامك
          لمواقع الطرف الثالث.
        </TermsOfUseSection>

        <TermsOfUseSection title="7. تحديد المسؤولية">
          "وي ار يونيترز" غير مسؤول عن أي أضرار أو خسائر تنجم عن استخدام موقعنا
          الإلكتروني أو خدماتنا. استخدامك لموقعنا الإلكتروني على مسؤوليتك
          الخاصة.
        </TermsOfUseSection>

        <TermsOfUseSection title="8. التغييرات على شروط الاستخدام">
          قد نقوم بتحديث شروط الاستخدام هذه من وقت لآخر. سيتم نشر أي تغييرات على
          موقعنا الإلكتروني، ومن مسؤوليتك مراجعتها دوريًا. استمرار استخدامك
          لموقعنا الإلكتروني بعد إجراء التغييرات يُعد قبولًا منك للشروط المعدلة.
        </TermsOfUseSection>

        <TermsOfUseSection title="9. القانون الحاكم">
          ان الشركة غير مسئولة عن اي تعاملات بين الطرف المستفيد من خدمات الشركة
          و اي من افرادها و انما الشركة مسئولة عن التحويلات المالية بين الطرف
          المستفيد من الشركة و الحساب الرسمي لها فقط
        </TermsOfUseSection>

        <TermsOfUseSection title="10. معلومات الاتصال">
          إذا كانت لديك أي أسئلة أو استفسارات بخصوص شروط الاستخدام هذه، يُرجى
          الاتصال بنا باستخدام المعلومات المقدمة في قسم "معلومات الاتصال" في
          سياسة الخصوصية.
        </TermsOfUseSection>

        <TermsOfUseSection title="11. لا يوجد استرداد بعد 14 يومًا من إنشاء الحساب الشخصي">
          تم آخر تحديث لهذه الشروط في 10 أغسطس 2024. شكرًا لاختيارك "وي ار
          يونيترز"، ونقدر التزامك بهذه الشروط.
        </TermsOfUseSection>
      </div>
    </>
  );
};

export default TermsOfUse;
